import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ApplicationStatusEnum } from '@tran-monorepo/interfaces/applications';
import { ApplicationStatusBadgeComponent } from '../application-status-badge/application-status-badge.component';

@Component({
    selector: 'tran-application-status-indicator',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, ApplicationStatusBadgeComponent],
    templateUrl: './application-status-indicator.component.html'
})
export class ApplicationStatusIndicatorComponent {
    public readonly status = input.required<ApplicationStatusEnum>();

    protected readonly ApplicationStatus = ApplicationStatusEnum;
}
